module.exports = __webpack_public_path__ + "img/zhongjian.e55a52f0.png";